module.exports = __webpack_public_path__ + "img/Favicon FIL bleue.8259c82f.svg";